import request from "utils/request";

export async function getSiteSelections() {
	return request("/rest/site_selections");
}

export async function createSiteSelection(payload) {
	return request("/rest/site_selections", {
		method: "PUT",
		body: payload
	});
}

export async function renameSiteSelection(payload) {
	return request("/action/rename/site_selection", {
		method: "POST",
		body: payload
	});
}

export async function saveSiteSelection(payload) {
	return request("/rest/site_selections/" + payload.siteSelection.id, {
		method: "POST",
		body: payload
	})
}

export async function deleteSiteSelections(ids) {
	return request("/rest/site_selections", {
		method: "DELETE",
		body: ids
	});
}

export async function getSiteSelection(id) {
	return request("/rest/site_selections/" + id);
}